import { LogsService } from "@gtpl/shared-services/user-logs";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { Route } from "./entity/route.entity";
import { RouteAdapter } from "./route.adapter";
import { RouteController } from "./route.controller";
import { RouteService } from "./route.service";

@Module({
    imports: [
      TypeOrmModule.forFeature([Route]),
    ],
    controllers: [RouteController],
    providers: [RouteService,RouteAdapter,ApplicationExceptionHandler,LogsService]
  })
  export class RouteModule {}